// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1W-ex","col":"styles_col__kCMTl","actions":"styles_actions__2wCOF","conflict":"styles_conflict__3zQSr"};